import { CheckCircleFilled } from '@ant-design/icons'
import React from 'react'
import { DriverCreationFormType } from 'Types/new_driver_types';
import "./verification-screen.scss";

interface VerificationScreenProps {
    // TODO: add more type
    fetchedPersonnel:DriverCreationFormType;
    messages:{
        successMsg:string;
        reviewMsg:string;
        emailMsg:string;
        appResultMsg:string;
        idMsg:string;
    }
}

const VerificationScreen:React.FC<VerificationScreenProps> = ({
    fetchedPersonnel,
    messages,
}) => {

    return (
        <div className='create-success-container'>
            <div>
                <CheckCircleFilled
                    style={{ fontSize: 100, color: "#29A7D3" }}
                />
            </div>
            <div className="mt-25">
                {messages.successMsg}
            </div>
            <div><span className='rider-name'>{fetchedPersonnel?.fullName || ""}</span>{messages.reviewMsg}</div>
            <div className="mt-25">
                {messages.emailMsg} <span className='link'>{fetchedPersonnel?.emailAddress || ""}</span>
            </div>
            <div>{messages.appResultMsg}</div>
            {
                fetchedPersonnel?.code ?
                    <div className="mt-25">
                        {messages.idMsg}<br /> <span className='link'>{fetchedPersonnel?.code}</span>
                    </div> : null
            }
        </div>
    )
}

export default VerificationScreen